import { InformationsPreAssurabilite } from "../../../models";
import React from "react";
import { CSSTransition } from "react-transition-group";
import Loading from "./../Loading";
import Assure from "./Assure";
import { INavigationParcours } from "../../../util/Navigation";

interface IQuestionnaireProps {
  informationsPreAssurabilite: InformationsPreAssurabilite;
  enChargement: boolean;
  idAssure: string;
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
}

function Questionnaire(props: Readonly<IQuestionnaireProps>) {
  const questions = props.informationsPreAssurabilite.questions;
  const nodeRef = React.useRef(null);

  return (
    <CSSTransition nodeRef={nodeRef} in={!props.enChargement} timeout={100} classNames="questionnaire-transition">
      <div data-testid="questionnaire-validation" ref={nodeRef}>
        {props.enChargement ? (
          <Loading />
        ) : (
          <Assure
            questions={questions}
            informationsPreAssurabilite={props.informationsPreAssurabilite}
            idAssure={props.idAssure}
            cookieParcoursAssurance={props.cookieParcoursAssurance}
            parcours={props.parcours}
          />
        )}
      </div>
    </CSSTransition>
  );
}

export default Questionnaire;
